import { paginatedTransform } from 'src/services/skuit/utils'
import { Lost, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from '../skuit/types'

import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[],
  exportFilters: ExportFilters,
}

export class LostAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Lost>> => {
    const response = await this.api.get('/logistics/lost', config)
    return paginatedTransform(Lost)(response.data)
  }

  export = async ({ fields, exportFilters }: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid}
    const response = await this.api.axiosInstance({
      url: 'logistics/lost/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, (guid ? `lost_product_${guid}.csv` : 'lost.csv')) 
  }
}
